import "./AboutUs.css";
import React from "react";

const AboutUs = ({ sectionRef }) => {
  return (
    <div className="aboutUs__container" id="about" ref={sectionRef}>
      <div className="aboutUs__headline">
        <p className="headline--about">Since 2021</p>
        <p className="aboutUs__headline--p">
          A hiring partner built for growth. We believe great hiring is more
          than filling individual roles—it’s about building a scalable hiring
          function that supports long-term growth.
        </p>
      </div>
      <div className="aboutUs__text__container">
        <p className="aboutUs__text--p first_para">
          That means understanding your company, your team, and how your hiring
          needs evolve over time.
        </p>
      </div>
      <div className="aboutUs__text__container">
        <p className="aboutUs__text--p second_para">
          Whether we're helping with one critical hire or supporting hiring
          across multiple departments, our goal is the same: create a hiring
          process that becomes stronger as your company grows.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
